import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { AlertCircleIcon, BrainIcon, ActivityIcon } from 'lucide-react';
export function ProblemSection() {
  return <Section id="problem" background="white" data-id="element-165">
      <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-167">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-168">
            Tu cuerpo está en alerta
          </h2>
          <ul className="space-y-4" data-id="element-169">
            {['Mandíbula tensa', 'Respiración corta', 'Irritabilidad', 'Sueño ligero', 'Cansancio con nervio', 'Mente que no para'].map((item, i) => <li key={i} className="flex items-center text-lg text-gray-700 p-3 bg-warm-white rounded-lg border border-warm-gray/50" data-id="element-170">
                <ActivityIcon className="h-5 w-5 text-teal mr-3 flex-shrink-0" data-id="element-171" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-navy text-white p-8 rounded-2xl shadow-xl" data-id="element-172">
          <h3 className="text-2xl font-bold mb-4 flex items-center" data-id="element-173">
            <AlertCircleIcon className="h-6 w-6 text-teal mr-2" data-id="element-174" />Y lo peor...
          </h3>
          <p className="text-xl leading-relaxed opacity-90" data-id="element-175">
            Cuando intentas calmarte,{' '}
            <strong className="text-teal-light" data-id="element-176">no se calma</strong>.
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-center max-w-3xl mx-auto bg-warm-white p-8 md:p-12 rounded-3xl border border-warm-gray" data-id="element-177">
        <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-178">
          Por qué no se calma{' '}
          <span className="text-teal" data-id="element-179">(y por qué no es culpa tuya)</span>
        </h2>

        <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-180">
          Porque estás tratando de arreglarlo desde la mente… con un cuerpo
          activado. En modo alarma, la mente se vuelve solucionadora compulsiva
          y todo se siente urgente.
        </p>

        <div className="inline-block bg-white px-8 py-4 rounded-full shadow-md border border-teal/20" data-id="element-181">
          <p className="text-xl md:text-2xl font-bold text-navy flex items-center justify-center gap-3" data-id="element-182">
            <BrainIcon className="h-6 w-6 text-teal" data-id="element-183" />
            No estás roto/a. Estás{' '}
            <span className="text-teal underline decoration-2 underline-offset-4" data-id="element-184">
              activado/a
            </span>
            .
          </p>
        </div>
      </motion.div>
    </Section>;
}